export default `
  query customer($orderNumber: String!) {
    customer {
        orders(scope: WEBSITE, filter: { number: { eq: $orderNumber } }) {
            items {
                number
                order_date
                shipment_status
                id
                track_trace {
                    code
                    url
                }
                shipping_address {
                    firstname
                    lastname
                    telephone
                    city
                    company
                    middlename
                    postcode
                    region
                    street
                }
                shipping_method
                payment_methods {
                    name
                    type
                }
                created_at
                carrier
                billing_address {
                    firstname
                    lastname
                    telephone
                    city
                    company
                    middlename
                    postcode
                    region
                    street
                }
                items(pageSize: 3) {
                    eligible_for_return
                    id
                    product_name
                    product_sku
                    product_type
                    product_url_key
                    quantity_invoiced
                    quantity_ordered
                    quantity_refunded
                    quantity_returned
                    quantity_shipped
                    selected_options {
                        label
                        value
                    }
                    product_sale_price {
                        value
                    }
                    entered_options {
                        label
                        value
                    }
                    product {
                        image {
                            url
                        }
                    }
                }
                total {
                    discounts {
                        label
                        amount {
                            value
                        }
                    }
                    grand_total {
                        value
                    }
                    shipping_handling {
                        amount_including_tax {
                            value
                        }
                    }
                    subtotal {
                        value
                    }
                    total_tax {
                        value
                    }
                }
            }
        }
    }
}
`
